import { render, staticRenderFns } from "./PersonalAccessTokens.vue?vue&type=template&id=e810c43e&scoped=true&"
import script from "./PersonalAccessTokens.vue?vue&type=script&lang=js&"
export * from "./PersonalAccessTokens.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAccessTokens.vue?vue&type=style&index=0&id=e810c43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e810c43e",
  null
  
)

export default component.exports